// Import environment configuration
import './env-config.js';

const styleOptions = {
  hideUploadButton: true,
  sendBoxTextWrap: true,

  backgroundColor: '#ffffff',
  accent: '#00809d',
  botAvatarBackgroundColor: '#ec660d',
  botAvatarImage: '/Bob-icon.png',
  botAvatarInitials: 'V',
  avatarSize: 60,
  userAvatarImage: 'https://avatars.githubusercontent.com/u/661465',

  bubbleBackground: '#ffffff',
  bubbleBorderRadius: 10,
  bubbleBorderWidth: 2,
  bubbleBorderColor: '#cfcfcf',
  bubbleFromUserBackground: '#ec660d',
  bubbleFromUserBorderColor: '#cfcfcf',
  bubbleFromUserBorderRadius: 10,
  bubbleFromUserBorderWidth: 0,
  bubbleFromUserTextColor: 'White',
  paddingRegular: 11,
  sendBoxBorderBottom: 'solid 1px #cfcfcf',
  sendBoxBorderLeft: 'solid 1px #cfcfcf',
  sendBoxBorderRight: 'solid 1px #cfcfcf',
  sendBoxBorderTop: 'solid 2.5px #cfcfcf',
  sendBoxHeight: 60,

  typingAnimationDuration: 7000,
  typingAnimationHeight: 20,
  typingAnimationWidth: 64,

  hideScrollToEndButton: false,
  autoScrollSnapOnActivity: false,
  autoScrollSnapOnActivityOffset: 0,
  autoScrollSnapOnPage: false,
  autoScrollSnapOnPageoffset: 0,

  suggestedActionBorderColor: '#ec660d',
  suggestedActionBorderRadius: 6,
  suggestedActionBorderWidth: 2,
  suggestedActionTextColor: '#ec660d',

  rootHeight: '100%',
  rootWidth: '100%'
}

// Configuration from generated config file
const config = {
    auth: {
        clientId: window.APP_CONFIG.auth.clientId,
        authority: window.APP_CONFIG.auth.authority,
        redirectUri: window.location.origin
    },
    cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: false
    }
};

const copilotConfig = {
    environmentId: window.APP_CONFIG.copilot.environmentId,
    agentIdentifier: window.APP_CONFIG.copilot.agentIdentifier
};

// Required scopes for Copilot Studio
const loginRequest = {
    scopes: ['https://api.powerplatform.com/.default']
};

// Initialize MSAL
const msalInstance = new msal.PublicClientApplication(config);

let conversationClient = null;
let currentConversationId = null;

// UI Elements
const chatSection = document.getElementById('chatSection');
const restartBtn = document.getElementById('restartBtn');
const messageInput = document.getElementById('messageInput');
const sendBtn = document.getElementById('sendBtn');
const chatMessages = document.getElementById('chatMessages');
const statusIndicator = document.getElementById('statusIndicator');

// Initialize the app
async function initialize() {
    try {
        await msalInstance.initialize();
        
        // Handle redirect response
        const response = await msalInstance.handleRedirectPromise();
        if (response) {
            await handleLoginSuccess(response);
            return;
        }
        
        // Check if user is already logged in
        const accounts = msalInstance.getAllAccounts();
        if (accounts.length > 0) {
            msalInstance.setActiveAccount(accounts[0]);
            await initializeChatClient();
        } else {
            // No existing session - automatically trigger login with redirect
            // This avoids popup blockers by using redirect instead of popup
            await msalInstance.loginRedirect(loginRequest);
        }
    } catch (error) {
        console.error('Initialization error:', error);
        showError('Failed to initialize application');
    }
}



// Restart handler
restartBtn.addEventListener('click', async () => {
    try {
        // Clear the chat messages
        chatMessages.innerHTML = '';
        
        // Disable input temporarily
        messageInput.disabled = true;
        sendBtn.disabled = true;
        messageInput.value = '';
        
        // Update status
        updateStatus('Restarting...', 'connecting');
        
        // Start a new conversation
        await startConversation();
        
        updateStatus('Connected', 'connected');
    } catch (error) {
        console.error('Restart error:', error);
        showError('Failed to restart conversation: ' + error.message);
        updateStatus('Connection failed', 'error');
    }
});

// Handle successful login
async function handleLoginSuccess(response) {
    msalInstance.setActiveAccount(response.account);
    await initializeChatClient();
}

// Get access token
async function getAccessToken() {
    const account = msalInstance.getActiveAccount();
    if (!account) {
        throw new Error('No active account');
    }

    try {
        const response = await msalInstance.acquireTokenSilent({
            ...loginRequest,
            account: account
        });
        return response.accessToken;
    } catch (error) {
        if (error instanceof msal.InteractionRequiredAuthError) {
            return await msalInstance.acquireTokenRedirect(loginRequest);
        }
        throw error;
    }
}

// Initialize Copilot Studio chat client
async function initializeChatClient() {
    try {
        updateStatus('Initializing chat...', 'connecting');
        
        const token = await getAccessToken();
        
        // Create the Copilot Studio client connection settings
        const settings = {
            environmentId: copilotConfig.environmentId,
            agentIdentifier: copilotConfig.agentIdentifier
        };
        
        // Initialize the Copilot Studio client
        const { CopilotStudioClient } = window.MicrosoftAgents;
        conversationClient = new CopilotStudioClient(settings, token);
        
        showChatSection();
        updateStatus('Connected', 'connected');
        
        // Start a conversation
        await startConversation();
        
        
        
    } catch (error) {
        console.error('Chat client initialization error:', error);
        showError('Helaas is het niet gelukt om connectie te maken: ' + error.message);
        updateStatus('Connection failed', 'error');
    }
}

// Start a new conversation
async function startConversation() {
    try {
        // Start conversation with the Copilot Studio agent
        const activity = await conversationClient.startConversationAsync(true);
        
        currentConversationId = activity.conversation.id;
        console.log('Conversation started:', currentConversationId);
        
        // Show any initial message from the agent
        if (activity.text) {
            addAgentMessage(activity.text);
        }
        
        // Show suggested actions if any
        if (activity.suggestedActions && activity.suggestedActions.actions) {
            addSuggestedActions(activity.suggestedActions.actions);
        }
        
        // Enable input
        messageInput.disabled = false;
        sendBtn.disabled = false;
        messageInput.focus();
        
    } catch (error) {
        console.error('Failed to start conversation:', error);
        throw error;
    }
}

// Send message
async function sendMessage() {
    const message = messageInput.value.trim();
    if (!message || !currentConversationId) return;

    let conversationEnded = false;

    try {
        // Disable input while sending
        messageInput.disabled = true;
        sendBtn.disabled = true;

        // Add user message to chat
        addUserMessage(message);
        messageInput.value = '';

        // Show typing indicator
        showTypingIndicator();

        // Send message to Copilot Studio and get responses
        const replies = await conversationClient.askQuestionAsync(message, currentConversationId);
        
        removeTypingIndicator();
        
        // Process all replies from the agent
        replies.forEach(activity => {
            if (activity.type === 'message') {
                addAgentMessage(activity.text);
                
                // Show suggested actions if any
                if (activity.suggestedActions && activity.suggestedActions.actions) {
                    addSuggestedActions(activity.suggestedActions.actions);
                }
            } else if (activity.type === 'endOfConversation') {
                addSystemMessage('Conversation ended by agent.');
                conversationEnded = true;
            }
        });

    } catch (error) {
        console.error('Send message error:', error);
        showError('Failed to send message: ' + error.message);
        removeTypingIndicator();
    } finally {
        // Re-enable input unless conversation ended
        if (!conversationEnded) {
            messageInput.disabled = false;
            sendBtn.disabled = false;
            messageInput.focus();
        }
    }
}



// UI Helper functions
function showChatSection() {
    chatSection.classList.remove('hidden');
}

function updateStatus(text, statusClass) {
    statusIndicator.textContent = text;
    statusIndicator.className = 'status ' + statusClass;
}

function addUserMessage(text) {
    const messageDiv = document.createElement('div');
    messageDiv.className = 'message user-message';
    messageDiv.innerHTML = `
        <div class="message-content">
            <div class="message-text">${escapeHtml(text)}</div>
            <div class="message-time">${formatTime(new Date())}</div>
        </div>
    `;
    chatMessages.appendChild(messageDiv);
    scrollToBottom();
}

function addAgentMessage(text) {
    const messageDiv = document.createElement('div');
    messageDiv.className = 'message agent-message';
    messageDiv.innerHTML = `
        <div class="message-avatar">
            <img src="/Bob-icon.png" alt="Bob" style="width: 40px; height: 40px; border-radius: 50%; object-fit: cover;">
        </div>
        <div class="message-content">
            <div class="message-text">${parseMarkdown(text)}</div>
            <div class="message-time">${formatTime(new Date())}</div>
        </div>
    `;
    chatMessages.appendChild(messageDiv);
    scrollToBottom();
}

function addSystemMessage(text) {
    const messageDiv = document.createElement('div');
    messageDiv.className = 'message system-message';
    messageDiv.innerHTML = `
        <div class="message-text">${escapeHtml(text)}</div>
    `;
    chatMessages.appendChild(messageDiv);
    scrollToBottom();
}

function addSuggestedActions(actions) {
    // Remove any existing suggested actions first
    const existingActions = document.querySelector('.suggested-actions');
    if (existingActions) {
        existingActions.remove();
    }

    if (!actions || actions.length === 0) return;

    const actionsDiv = document.createElement('div');
    actionsDiv.className = 'suggested-actions';
    
    actions.forEach(action => {
        const button = document.createElement('button');
        button.className = 'suggested-action-button';
        button.textContent = action.title || action.value || action.text;
        button.onclick = () => handleSuggestedAction(action);
        actionsDiv.appendChild(button);
    });
    
    chatMessages.appendChild(actionsDiv);
    scrollToBottom();
}

function handleSuggestedAction(action) {
    // Get the action text/value to send
    const actionValue = action.value || action.title || action.text;
    
    // Set the input value and trigger send
    messageInput.value = actionValue;
    sendMessage();
}

function showTypingIndicator() {
    const typingDiv = document.createElement('div');
    typingDiv.className = 'message agent-message typing-indicator';
    typingDiv.id = 'typingIndicator';
    typingDiv.innerHTML = `
        <div class="message-content typing-content">
            <img src="/Bob-icon.png" alt="Bob thinking" class="typing-icon">
            <div class="typing-text">Bob is aan het nadenken, even geduld...</div>
        </div>
    `;
    chatMessages.appendChild(typingDiv);
    scrollToBottom();
}

function removeTypingIndicator() {
    const typingDiv = document.getElementById('typingIndicator');
    if (typingDiv) {
        typingDiv.remove();
    }
}

function showError(message) {
    addSystemMessage('⚠️ Error: ' + message);
}

function scrollToBottom() {
    chatMessages.scrollTop = chatMessages.scrollHeight;
}

function parseMarkdown(text) {
    // Escape HTML first to prevent XSS
    let html = escapeHtml(text);
    
    // Parse markdown formatting
    // Bold: **text** or __text__
    html = html.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
    html = html.replace(/__(.+?)__/g, '<strong>$1</strong>');
    
    // Italic: *text* or _text_
    html = html.replace(/\*(.+?)\*/g, '<em>$1</em>');
    html = html.replace(/_(.+?)_/g, '<em>$1</em>');
    
    // Code: `code`
    html = html.replace(/`(.+?)`/g, '<code>$1</code>');
    
    // Links: [text](url)
    html = html.replace(/\[(.+?)\]\((.+?)\)/g, '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>');
    
    // Line breaks
    html = html.replace(/\n/g, '<br>');
    
    return html;
}

function escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
}

function formatTime(date) {
    return date.toLocaleTimeString('en-US', { 
        hour: 'numeric', 
        minute: '2-digit',
        hour12: true 
    });
}

// Event listeners
sendBtn.addEventListener('click', sendMessage);

messageInput.addEventListener('keypress', (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        sendMessage();
    }
});

messageInput.addEventListener('input', () => {
    // Auto-resize textarea
    messageInput.style.height = 'auto';
    messageInput.style.height = messageInput.scrollHeight + 'px';
    
    // Enable/disable send button
    sendBtn.disabled = !messageInput.value.trim();
});

// Initialize app on load
initialize();
